/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import leftBG from '../../../../../assets/component003-left.png';
import rightBG from '../../../../../assets/component003-right.png';

import './component003.less';

interface IComponent003Props {
  text: string;
  position?: 'left' | 'right';
  img?: string;
  title?: string;
  className?: string | null;
}

const Component003: React.FunctionComponent<IComponent003Props> = ({
  text,
  position,
  img,
  title,
  className,
}) => (
  <div className={`component003 position-${position} ${className}`}>
    {title && (
      <div
        className="component003-title"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    )}
    <div className="component003-tip">
      <span className="tip-text" dangerouslySetInnerHTML={{ __html: text }} />
      <div className="tip-arrow">
        <div className="line1" />
        <div className="line2" />
      </div>
    </div>
    <img
      src={
        img
          ? require(`../../../../../assets/${img}`).default
          : position === 'left'
          ? leftBG
          : rightBG
      }
      alt=""
    />
  </div>
);

Component003.defaultProps = {
  position: 'left',
};

export default Component003;
